export default __webpack_public_path__ + "static/m-banh4-a40f2b9f98d06b738596da7e062e2b48.jpg";